import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type { AnalyticsAttributes } from '@atlassian/jira-product-analytics-bridge';

export const fireError = (
	messageOrError: string | Error,
	location: string,
	attributes?: AnalyticsAttributes,
): void => {
	const errorObject = messageOrError instanceof Error ? messageOrError : new Error(messageOrError);

	fireErrorAnalytics({
		error: errorObject,
		meta: {
			id: location,
			packageName: 'jiraAccessibleWorkflowDiagram',
			teamName: 'helix',
		},
		skipSentry: false,
		attributes,
	});
};
